export default {
    attachment: "/gateway/huilianApi/uploader/attachment", // 图片上传

    h5: {
        sendCertificateCode:
            "/gateway/huilianCust/realCustcs/sendCertificateCode",
    },
};



// WEBPACK FOOTER //
// ./src/identityVerification/modules/attestationType/api.js